<template>
  <v-content class="mx-4">

    <v-layout>
      <v-flex my-2 style="text-align: left;">
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD;">จัดการบัญชีผู้ใช้</span>
        </v-btn>
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1" @click="$router.push('/manage-user-accounts').catch(err => {})">
          <span style="color: #BDBDBD;">บัญชีผู้ใช้งานทั้งหมด</span>
        </v-btn>
        <v-icon style="color: #527281">arrow_right</v-icon>
        <v-btn style="color: #527281" text class="px-1">
          <span>แก้ไข/ลบ</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout class="button-taps" >
      <v-flex shrink style="text-align: left;">
        <v-btn class="mr-1" :class="{active: tap === 1}"  @click="$router.push('/manage-user-accounts').catch(err => {})"
               style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          บัญชีผู้ใช้งานทั้งหมด
        </v-btn>
      </v-flex>
      <v-flex shrink style="text-align: left;">
        <v-btn class="mr-1"  @click="$router.push('/manage-user-accounts').catch(err => {})"
               style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          จัดการหน่วยงาน
        </v-btn>
      </v-flex>
    </v-layout>

    <!-- Header Add Account -->
    <template>
      <v-layout>
        <v-flex xs12 py-4 px-3 style="text-align: left;color: white;background-color: #84A2A8;">
          <v-layout>
            <v-flex shrink mr-4>
              <span style="font-size: 24px;font-weight: bold;">แก้ไข/ลบบัญชีผู้ใช้งาน</span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex pa-4 style="background-color: #527281;">
        </v-flex>
      </v-layout>

      <!-- Conponent Form Add Account -->
      <v-layout justify-center class="table-search">
        <v-flex>
          <form-manage-account :isEdit="true"></form-manage-account>
        </v-flex>
      </v-layout>

    </template>
  </v-content>
</template>

<script>
    import FormManageAccount from "../components/FormManageAccount";

    export default {
        name: "EditAndDeleteAccount",
        components: {
            FormManageAccount,
        },
        data: () => ({
            tap: 1,

        })
    }
</script>

<style scoped>

</style>
